const _ = require('lodash');
const moment = require('moment');
const defaultState = {
    ioList: [],
    ioDetail: {},
    loading: false,
    loadingHist: false,
    errors:{},
    lastFiltersIO:[],
    ioHist:[]
}
  
export default (state=defaultState, action={}) => {
    switch (action.type) {

        case 'FETCH_IO_FULFILLED': {
            let arrayMain=[];
            let newItem = {};
            let indipsMode = '';
            
            if(Array.isArray(action.payload.data)){
                action.payload.data.forEach((element,index) => {
                    newItem = {};
                    newItem = element;//limpa para criar um novo
                    indipsMode = element.FLAG_G === 1 ? 'G ' : '';
                    indipsMode = element.FLAG_GT === 1 ? indipsMode + 'GT ' : indipsMode + '';
                    indipsMode = element.FLAG_GC === 1 ? indipsMode + 'CG' : indipsMode + '';
                    indipsMode = element.FLAG_B === 1 ? indipsMode + 'B ' : indipsMode + '';
                    indipsMode = element.FLAG_BT === 1 ? indipsMode + 'BT ' : indipsMode + '';
                    indipsMode = element.FLAG_BC === 1 ? indipsMode + 'CB' : indipsMode + '';
                    newItem["indispMode"] = indipsMode;
                    newItem["BEGIN_DATETIME_LOCAL"] = moment.utc(element.BEGIN_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');
                    newItem["END_DATETIME_LOCAL"] = moment.utc(element.END_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');

                    //fazer set de state destes valores como auxiliares para criar valdiações
                    arrayMain.push(newItem);
                });        
            }else{
                console.log('FETCH_IO_FULFILLED error: ');
                console.dir(action.payload.data);
            }

            return {
                ...state,
                ioList: arrayMain,
                loading: false,
                errors: {}
            }
        }
    
        case 'FETCH_IO_PENDING': {
            return {
            ...state,
            loading: true,
            errors: {}
            }
        }
    
        case 'FETCH_IO_REJECTED': {
            return {
            ...state,
            loading: false,
            errors: { global: action.payload.message }
            }
        }

        case 'FETCH_IO_DETAIL_FULFILLED': {
            const id = action.payload.data[0].ID;
            const status = action.payload.data[0].STATUS;
            const idCI = action.payload.data[0].ID_CI;
            
            return {
            ...state,
            ioDetail: action.payload.data[0],
            ioList: state.ioList.map(item => item.ID === id ? {...item, STATUS: status, ID_CI: idCI} : item),
            errors: {},
            loadingHist: false
            }
        }

        case 'FETCH_IO_DETAIL_PENDING': {
            return {
            ...state,
            loadingHist: true,
            ciDetail: {},
            errors: {}
            }
        }
        
        case 'FETCH_IO_DETAIL_REJECTED': {
            return {
            ...state,
            loadingHist: false,
            errors: { global: action.payload.message }
            }
        }      
        
        case 'LASTFILTER_IO': {        
            return {
            ...state,
            lastFiltersIO: action.payload
            }
        }      

        case 'FETCH_IO_HISTORY_FULFILLED': {
            let arrayMain=[];
            let newItem = {};
            let indipsMode = '';
            
            if(Array.isArray(action.payload.data)){
                action.payload.data.forEach((element,index) => {
                    newItem = {};
                    newItem = element;//limpa para criar um novo
                    indipsMode = element.FLAG_G === 1 ? 'G ' : '';
                    indipsMode = element.FLAG_GT === 1 ? indipsMode + 'GT ' : indipsMode + '';
                    indipsMode = element.FLAG_GC === 1 ? indipsMode + 'CG' : indipsMode + '';
                    indipsMode = element.FLAG_B === 1 ? indipsMode + 'B ' : indipsMode + '';
                    indipsMode = element.FLAG_BT === 1 ? indipsMode + 'BT ' : indipsMode + '';
                    indipsMode = element.FLAG_BC === 1 ? indipsMode + 'CB' : indipsMode + '';
                    newItem["indispMode"] = indipsMode;
            
                    //fazer set de state destes valores como auxiliares para criar valdiações
                    arrayMain.push(newItem);
                });
            }else{
                console.log('FETCH_IO_HISTORY_FULFILLED error: ');
                console.dir(action.payload.data);
            }
    
            return {
                ...state,
                ioHist: arrayMain,
                loadingHist: false,
                errors: {}
            }
          }
      
        case 'FETCH_IO_HISTORY_PENDING': {
            return {
                ...state,
                loadingHist: true,
                errors: {}
            }
        }
      
        case 'FETCH_IO_HISTORY_REJECTED': {
            return {
                ...state,
                loadingHist: false,
                errors: { global: action.payload.message }
            }
        }

        case 'REFRESH_IO_LIST': {      
            const id = action.payload['rejectIOId'];
            const prevStatus = action.payload['rejectIOStatus'];
            let auxDetail = _.cloneDeep(state.ioDetail);
            auxDetail['STATUS'] = prevStatus;
            return {
            ...state,
            ioList: state.ioList.map(item => item.ID === id ? {...item, STATUS: prevStatus} : item),
            ioDetail: auxDetail
            }
        }

        //cases de refresh do state com base em sockets emitidos pelo server
        case 'EDIT_IO_FULFILLED': {

            const id = action.editedRecord.ID;
            const auxEditedRecord = action.editedRecord;
            let indipsMode = auxEditedRecord.FLAG_G === 1 ? 'G ' : '';
            indipsMode = auxEditedRecord.FLAG_GT === 1 ? indipsMode + 'GT ' : indipsMode + '';
            indipsMode = auxEditedRecord.FLAG_GC === 1 ? indipsMode + 'CG' : indipsMode + '';
            indipsMode = auxEditedRecord.FLAG_B === 1 ? indipsMode + 'B ' : indipsMode + '';
            indipsMode = auxEditedRecord.FLAG_BT === 1 ? indipsMode + 'BT ' : indipsMode + '';
            indipsMode = auxEditedRecord.FLAG_BC === 1 ? indipsMode + 'CB' : indipsMode + '';
            auxEditedRecord["indispMode"] = indipsMode;
            return {
                ...state,
                ioList: state.ioList.map(item => item.ID === id 
                ? auxEditedRecord 
                : item
                )
            }
        }      
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/io-reducer.js